import styled from 'styled-components';
import theme from '../../../../styles/defaultTheme';
import Input from '../../../../components/Inputs/Input';
import DataTableMui from '../../../../components/DataTableMui';


export const SelectContainerFilter = styled.div`
	margin-bottom: 24px;
	width: 66%;
`;

export const ContainerIcons = styled.div`
	display: flex;
	gap: 0 22.66px;

	span {
		cursor: pointer;
	}
`;

export const ContainerFilter = styled.div`
  	display: flex;
  	gap: 0 24px;
`;

export const FiltersLabel = styled.label`
  	width: 100%;
	padding: 16px 0 8px 0 !important;
    display: flex;
	font: ${theme.font.body[1]};
	letter-spacing: 0px;
	color: ${(props) => props.theme.grey};
`;

export const ContainerTable = styled.div`
	margin: 0 -32px;

	& .alert {
		margin: 0 !important;
	}
`;

export const ContainerModalBody = styled.div`
	
`;

export const ContainerPermissions = styled.div`

`;

export const TableContent = styled.div`
    display: flex;
    justify-content: center;
`;

export const TableContainer = styled.div`
    margin: 0 32px;
	
    .in-analysis-pending-move > td:not(.status-column) {
		color: #5B5B5F !important;
	    opacity: 0.4 !important;
    }
`;

export const CustomInput = styled(Input)`
	width: 20%;
`;

export const TooltipText = styled.div`
    font: ${theme.font.body[2]};
    letter-spacing: 0px;
    color: ${(props) => props.theme.grey};
	font-family: inherit;
`;

export const CustomDataTableMui = styled(DataTableMui)`
`;
